import { operate } from "../util/lift";
import { createOperatorSubscriber } from "./OperatorSubscriber";
export function map(project, thisArg) {
  return operate(function (source, subscriber) {
    var index = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      subscriber.next(project.call(thisArg, value, index++));
    }));
  });
}